import { Role } from '__generated__/GQL';
import isEi from 'features/Onboarding/common/isEi';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import getCompanyPapersErrors from '../../../CompanyPapers/libs/getCompanyPapersErrors';
import getCompanyPapersStatus from '../../../CompanyPapers/libs/getCompanyPapersStatus';
import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import {
  GetVerificationStep,
  VerificationStatus,
  VerificationStepCategory,
} from './types';

const getCompanyPapersStep: GetVerificationStep = ({
  applicantType,
  applicationType,
  verificationData,
}) => {
  const { company, companyUser } = verificationData.viewer;

  const status = getCompanyPapersStatus({
    company,
    isAccountHolder: companyUser.roles.includes(Role.AccountHolder),
    kybDocuments: company.kybDocuments ?? [],
    lastKybReview: company.lastKybReview,
    legalForm: company.profile.legalForm,
  });

  const isOnboardingHub =
    applicationType === ApplicationType.Standard &&
    applicantType === ApplicantType.AccountHolder;

  return {
    errors: getCompanyPapersErrors({
      kybDocuments: company.kybDocuments ?? [],
    }),
    id: State.COMPANY_PAPERS,
    metadata: {
      category: VerificationStepCategory.CompanyInfo,
      event: model.events.GO_COMPANY_REGISTRATION(),
      iconName: 'company',
      isDisabled: status === VerificationStatus.Validated,
      ...(isOnboardingHub
        ? {
            label:
              locales.companyPapers.hub.label[
                isEi(company.profile.legalForm) ? 'ei' : 'nonEi'
              ],
          }
        : {
            label: locales.companyPapers,
          }),
    },
    status,
  };
};

export default getCompanyPapersStep;
